import { BasePage } from '@Tenants/Fun/Site/BasePage';
import { BaseCouponsAndDiscounts } from '@Base/CouponsAndDiscounts/CouponsAndDiscounts';

import "./CouponsAndDiscounts.scss";

export class CouponsAndDiscounts extends BaseCouponsAndDiscounts
{
	constructor()
	{
		super();
	}

	public Initialize(): void
	{
		this.SiteCoupons = [
			{
				Type: "subscribe",
				MobileCreativeID: "1143616",
				DesktopCreativeID: "1143618",
				SignUpSource: "FunUSPopup",
				ButtonSelector: ".subscribe-js"
			}
		];

		super.Initialize();
	}
}

export class CouponsAndDiscountsPage extends BasePage
{
	public CouponsAndDiscounts: CouponsAndDiscounts;

	constructor()
	{
		super();
		this.Initialize();
	}

	public async Initialize(): Promise<void>
	{
		super.Initialize();
		this.CouponsAndDiscounts = new CouponsAndDiscounts();
	}
}

const couponsAndDiscounts = new CouponsAndDiscountsPage();